
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as testnH_6bhumlghoyH1OAczusmJ_45Z1lVDINPPxdp70hFEc4Meta } from "/app/app/pages/test.vue?macro=true";
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_452EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as indexjXNYEFN_45y_45Gz_bcW6nAvlEyfFFaX2638uZSiOvoovo0Meta } from "/app/app/pages/docs/index.vue?macro=true";
import { default as indextQpbVDuCaIri5MRQIKVbLHbaYvNAizckm17gzYLOxnEMeta } from "/app/app/pages/drops/index.vue?macro=true";
import { default as _91slug_93obTEvLPe0q322_45RDtfSOTs4Y140eERV_QKosjuigqcAMeta } from "/app/app/pages/drops/[slug].vue?macro=true";
import { default as index2mkfczlx0nlrr0mvS_45dDCtGPoUrl6kgb9fR4wSqYqUQMeta } from "/app/app/pages/docs/eula/index.vue?macro=true";
import { default as _91owner_93fJs0ZqG87Nkh2_4585rIBfe7RS_Ap3NrBI10jhCVgGwFEMeta } from "/app/app/pages/profile/[owner].vue?macro=true";
import { default as indexHLU9XuhPrAnlZvKB6Ljbqy7OIE_4541xwDeWb4Wk86cNgMeta } from "/app/app/pages/collections/index.vue?macro=true";
import { default as _91slug_93qCF0uJ_3_45i_45nnhOZwrxHrf9T_45w3jWkBb99ef9wo37J8Meta } from "/app/app/pages/collections/[slug].vue?macro=true";
import { default as index2aJUk_mKRsub4aIONYuHwESGO6qDgN_4534j0VGOASZwAMeta } from "/app/app/pages/docs/terms-of-use/index.vue?macro=true";
import { default as indexRQZ1Y_452b8FmkrTTWJCwOOGLzpUYfdG_45qPC8w4AJlTjgMeta } from "/app/app/pages/docs/cookie-policy/index.vue?macro=true";
import { default as indexOA7huiUNn_45AdbmrksCprdxQbNcZrss8V5KuttVkgem4Meta } from "/app/app/pages/docs/privacy-policy/index.vue?macro=true";
import { default as indexKj95pTQjjcX_45_4531WF5gmBS0aHmbvrscC6_mcj3teP1AMeta } from "/app/app/pages/docs/disclaimer-nfts/index.vue?macro=true";
import { default as index5HYmgV0dUxqysRUK2HGsVBk_45_45ZOa_45Zp4Sqzzuhm61S8Meta } from "/app/app/pages/docs/service-provider/index.vue?macro=true";
import { default as _91identifier_93hl9x5f_e9XVsOX9fC6VkhSFqH5DttPdEBaj4PECfNJAMeta } from "/app/app/pages/collections/[collection]/[identifier].vue?macro=true";
export default [
  {
    name: "test",
    path: "/test",
    component: () => import("/app/app/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "docs",
    path: "/docs",
    component: () => import("/app/app/pages/docs/index.vue")
  },
  {
    name: "drops",
    path: "/drops",
    component: () => import("/app/app/pages/drops/index.vue")
  },
  {
    name: "drops-slug",
    path: "/drops/:slug()",
    component: () => import("/app/app/pages/drops/[slug].vue")
  },
  {
    name: "docs-eula",
    path: "/docs/eula",
    component: () => import("/app/app/pages/docs/eula/index.vue")
  },
  {
    name: "profile-owner",
    path: "/profile/:owner()",
    meta: _91owner_93fJs0ZqG87Nkh2_4585rIBfe7RS_Ap3NrBI10jhCVgGwFEMeta || {},
    component: () => import("/app/app/pages/profile/[owner].vue")
  },
  {
    name: "collections",
    path: "/collections",
    component: () => import("/app/app/pages/collections/index.vue")
  },
  {
    name: "collections-slug",
    path: "/collections/:slug()",
    component: () => import("/app/app/pages/collections/[slug].vue")
  },
  {
    name: "docs-terms-of-use",
    path: "/docs/terms-of-use",
    component: () => import("/app/app/pages/docs/terms-of-use/index.vue")
  },
  {
    name: "docs-cookie-policy",
    path: "/docs/cookie-policy",
    component: () => import("/app/app/pages/docs/cookie-policy/index.vue")
  },
  {
    name: "docs-privacy-policy",
    path: "/docs/privacy-policy",
    component: () => import("/app/app/pages/docs/privacy-policy/index.vue")
  },
  {
    name: "docs-disclaimer-nfts",
    path: "/docs/disclaimer-nfts",
    component: () => import("/app/app/pages/docs/disclaimer-nfts/index.vue")
  },
  {
    name: "docs-service-provider",
    path: "/docs/service-provider",
    component: () => import("/app/app/pages/docs/service-provider/index.vue")
  },
  {
    name: "collections-collection-identifier",
    path: "/collections/:collection()/:identifier()",
    component: () => import("/app/app/pages/collections/[collection]/[identifier].vue")
  }
]